export class NumberToString {

    convert(num) {
        let alphabet = 'ABCDEFGHIJKLMNÑOPQRSTUVWXYZ';
        return alphabet.charAt(num);
    }
}
